<template>
  <b-container fluid class="form register-form bg-white">
    <b-row>
      <b-col lg="6" md="6" sm="12" class="left-side position-relative"
        :class="step === 1 || (step === 3 && !canCreateOwnerOperatorCompany) || step === 4 ? 'vh-100' : ''">
        <LanguageFlagDropdown class="login-lang-switcher" />
        <b-row>
          <b-col lg="12" md="9" sm="12" class="m-md-0 my-0 my-md-5">
            <div class="fix-width register" :class="step === 2 ? 'register-steppers' : ''">
              <div class="logo mb-3 pb-3 text-left">
                <b-img class="" :src="require('@/assets/new-logo.png')" width="300" height="50"></b-img>
              </div>
              <!-- <div class="heading text-left mb-4">
                <h1 class="mb-0">Register account</h1>
                <p>Get your Digital Permit Book, account now.</p>
              </div> -->
              <Step1 :checkUserEmailExists="checkUserEmailExists" :user="user" v-if="step === 1" :userExists="userExists"
                :onLogin="onLogin" :newUser="newUser" :verifyUserEmail="verifyUserEmail" />
              <Step2 :onSignUp="onSignUp" :user="user" v-else-if="step === 2" />
              <!-- <Step3 :getCompanyDetailsfromUsdot="getCompanyDetailsfromUsdot" v-else-if="step === 3" :company="company" /> -->
              <Step3 :company="company" :canCreateOwnerOperatorCompany="canCreateOwnerOperatorCompany"
                :createUserCompany="createUserCompany" v-else-if="step === 3" @getStates="getStates($event)" />
              <Step4 :companyID="companyID" v-else />
              <!-- <Step4/> -->
              <div class="signup mt-3 text-center" v-if="step < 4">
                {{ $t('register.alreadyHaveAccount') }}
                <router-link to="/login">{{ $t('register.loginLink') }}</router-link>
              </div>
              <div class="otp-bubble mt-5 text-center" v-if="step === 1 && newUser && !userExists">
                <p class="mb-0 f-14">{{ $t('register.otpSentNote') }}</p>
              </div>
              <div class="otp-bubble mt-5 text-left" v-if="step === 3 && canCreateOwnerOperatorCompany">
                <p class="mb-0 f-14">
                  <b>{{ $t('register.companyTypeNote') }}</b>
                  <br /><br />
                  <b>{{ $t('register.fleetTitle') }}</b> {{ $t('register.fleetDescription') }}
                  <br /><br />
                  <b>{{ $t('register.ownerOperatorTitle') }}</b> {{ $t('register.ownerOperatorDescription') }}
                </p>
              </div>
              <!-- Drivers are onboarded by their carrier, never by signing up here. -->
              <div
                class="otp-bubble text-left"
                :class="(step === 1 && newUser && !userExists) || (step === 3 && canCreateOwnerOperatorCompany) ? 'mt-3' : 'mt-5'"
                v-if="step === 1"
              >
                <p class="mb-0 f-14">
                  <b>⚠️ {{ $t('register.driverNoticeTitle') }}</b>
                  <br />
                  {{ $t('register.driverNoticeText') }}
                </p>
              </div>
            </div>
          </b-col>
          <!-- <p class="mb-0 f-14 opacity-50 copyright-text">© {{new Date().getFullYear()}} Copyright Digital Permit Book LLC.</p> -->
        </b-row>
      </b-col>
      <b-col cols="6" md="6" class="p-0 auth-bg-img" :class="{ 'vh-100': isGeotabAddin }">
        <Auth class="" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Step1 from "@/components/auth/Registration/Step1.vue";
import Step2 from "@/components/auth/Registration/Step2.vue";
// import Step3 from "@/components/auth/Registration/Step3.vue";
import Step3 from "@/components/auth/Registration/Step4.vue";
import Step4 from "@/components/auth/Registration/Step5.vue";
import LanguageFlagDropdown from "@/components/Shared/LanguageFlagDropdown.vue";
import Auth from "@/components/auth/Auth.vue";
import { mapActions, mapGetters } from "vuex";
// import axios from "axios"
export default {
  components: { Step1, Step2, Step3, Step4, Auth, LanguageFlagDropdown },
  name: "Register",
  data() {
    return {
      step: 1,
      companyDetails: null,
      userExists: false,
      newUser: false,
      states: [],
      canCreateOwnerOperatorCompany: false,
      userKey: "",
      eulaAccepted: null,
      company: {
        company_name: "",
        company_id: "",
        expected_no_of_drivers: "",
        company_type: "",
      },
      companyID: null,
      user: {
        otp: "",
        last_name: "",
        first_name: "",
        email: "",
        phone_number: "",
        password1: "",
        password2: "",
      },
    };
  },
  computed: {
    ...mapGetters(["isGeotabAddin"])
  },
  methods: {
    ...mapActions(["setNotification", "registerUser", 'createCompanyOnly', "checkAdminUserExists", 'getCompanyDetails', 'updateCompany', 'loginUser', 'setLoader', 'verifyOtp', 'getSubscriptionDetails']),
    async onLogin() {
      try {
        const { key } = await this.loginUser({
          payload: {
            email: this.user.email,
            password: this.user.password1
          },
          registerCompany: true
        },);
        if (key) {
          this.userKey = key
          this.step = 3
        }
      }
      catch (error) {
        this.setNotification({
          msg: error,
          type: "error",
          color: "red",
        });
      }
    },
    async onSignUp() {
      try {
        delete this.user.otp
        this.setLoader(true)
        const attribution = this.getAttribution();
        const { key, eula_accepted_at } = await this.registerUser({
          ...this.user,
          ...(attribution ? { attribution } : {})
        })
        this.userKey = key
        this.eulaAccepted = eula_accepted_at
        this.step++
        this.setLoader(false)
      }
      catch (error) {
        this.setLoader(false)
        return this.setNotification({
          msg: error,
          type: "error",
          color: "red",
        });
      }
    },
    async verifyUserEmail() {
      try {
        await this.verifyOtp({
          email: this.user.email,
          otp: this.user.otp
        })
        this.setNotification({
          msg: this.$t('register.notifications.otpVerified'),
          type: "success",
          color: "green"
        })
        this.step = 2
      }
      catch (e) {
        this.setNotification({
          msg: this.$t('register.notifications.invalidOtp'),
          type: "error",
          color: "red",
        })
      }
    },
    getStates(states) {
      this.states = states
    },
    async checkUserEmailExists() {
      try {
        this.setLoader(true)
        const { status, can_create_owner_operator_company } = await this.checkAdminUserExists({ email: this.user.email })
        if (can_create_owner_operator_company) {
          this.canCreateOwnerOperatorCompany = can_create_owner_operator_company
        }
        else {
          this.company.company_type = '2'
        }
        if (status === 'OTP sent to your email.') {
          this.newUser = true
          this.setNotification({
            msg: this.$t('register.notifications.otpSent'),
            type: "success",
            color: "green",
          });
        }
        else if (status === 'User with this email already exists.') this.userExists = true
        this.setLoader(false)
      }
      catch (e) {
        this.userExists = false
        if (e.data && e.data.status) {
          if (e.data.status === 'User is not an admin.') {
            this.setNotification({
              msg: this.$t('register.notifications.onlyAdmins'),
              type: "error",
              color: "red",
            });
          }
          else if (e.data.status === 'Email already registered with owner-operator company') {
            this.setNotification({
              msg: e.data.status,
              type: "error",
              color: "red",
            });
            this.setLoader(false)
            return;
          }
        }
        this.setLoader(false)
      }
    },
    // async getCompanyDetailsfromUsdot() {
    //   delete axios.defaults.headers.common['Authorization']
    //   await axios.get(`https://mobile.fmcsa.dot.gov/qc/services/carriers/${this.company.usdot}?webKey=f5227198c16bc9926b6e86cd10131e62bdc1424a`).then((res) => {
    //     const { legalName, phyStreet, phyCity, phyState, phyZipcode } = res.data.content.carrier
    //     this.company = { ...this.company, company_name: legalName, address: phyStreet, city: phyCity, state: phyState, zipcode: phyZipcode }
    //   }).catch((e) => {
    //     console.log(e)
    //   }).finally(() => {
    //     this.step++
    //   })
    // },
    isNumber(value) {
      return typeof value === 'number' && !Number.isNaN(value) && Number.isFinite(value);
    },
    // The marketing site writes its cookies as encoded JSON; everything read out
    // of them goes through here so a malformed one can never break a sign-up.
    readJsonCookie(name) {
      try {
        const match = document.cookie
          .split(';')
          .find((cookie) => cookie.trim().startsWith(`${name}=`));
        if (!match) return null;
        // The value itself can hold "=", so only the first one is the separator.
        const raw = match.trim().slice(name.length + 1);
        return JSON.parse(decodeURIComponent(raw));
      } catch (e) {
        console.log(`Error parsing ${name} cookie:`, e);
        return null;
      }
    },
    // Google writes the click id as "GCL.<timestamp>.<id>", so the id is the
    // last part; it is only used when the attribution cookie has none of its own.
    getGclid() {
      const match = document.cookie
        .split(';')
        .find((cookie) => cookie.trim().startsWith('_gcl_aw='));
      if (!match) return '';
      const parts = decodeURIComponent(match.trim().slice('_gcl_aw='.length)).split('.');
      return parts.length > 2 ? parts.slice(2).join('.') : '';
    },
    // The cookie keeps the whole landing url, which still carries the campaign
    // it was clicked from — the click id in particular is only ever in there.
    landingUrl(value) {
      try {
        return value ? new URL(`${value}`) : null;
      } catch (e) {
        return null;
      }
    },
    // Where this sign-up came from, in the order the API itself uses: the
    // marketing site's first-touch cookie (dpb_ft), then its last-touch one
    // (dpb_attribution), then the campaign in this page's own url. The first
    // source with anything in it wins whole, so one visit's source is never
    // paired with another's campaign. Nothing tracked means nothing is claimed.
    // (The API can't read these itself: the cookies aren't sent cross-origin,
    // and this page's url never reaches it.)
    getAttribution() {
      return (
        this.attributionFrom(this.readJsonCookie('dpb_ft')) ||
        this.attributionFrom(this.readJsonCookie('dpb_attribution')) ||
        this.attributionFrom(this.pageAttribution()) ||
        // Nothing tracked at all can still carry Google's own click id.
        this.attributionFrom({})
      );
    },
    // This page's own ?utm_*= (or bare ?source=, ?gclid=) params, shaped like a
    // cookie so the same reader handles it. Unrelated params alone don't count.
    pageAttribution() {
      const query = this.$route.query || {};
      const campaignKeys = ['source', 'medium', 'campaign', 'term', 'content'];
      const tracked = Object.keys(query).some(
        (key) => campaignKeys.includes(key.replace(/^utm_/, '')) || key === 'gclid'
      );
      if (!tracked) return null;
      return {
        ...query,
        landing_url: window.location.href,
        referrer: document.referrer || '',
      };
    },
    attributionFrom(cookieData) {
      if (!cookieData || typeof cookieData !== 'object') return null;
      const data = cookieData;
      const read = (...names) => {
        const key = names.find(
          (name) => data[name] !== null && data[name] !== undefined && data[name] !== ''
        );
        return key ? `${data[key]}` : '';
      };
      const landing = this.landingUrl(data.landing_url || data.landingUrl);
      // A value the cookie did not name on its own is still in the url it kept.
      const fromLanding = (name) => (landing ? landing.searchParams.get(name) || '' : '');
      const attribution = {
        source: read('utm_source', 'source') || fromLanding('utm_source'),
        medium: read('utm_medium', 'medium') || fromLanding('utm_medium'),
        campaign: read('utm_campaign', 'campaign') || fromLanding('utm_campaign'),
        term: read('utm_term', 'term') || fromLanding('utm_term'),
        content: read('utm_content', 'content') || fromLanding('utm_content'),
        landing_page:
          read('landing_page', 'landing_path', 'landingPage', 'landing') ||
          (landing ? landing.pathname : ''),
        referrer: read('referrer', 'referer'),
        gclid: read('gclid') || fromLanding('gclid') || this.getGclid(),
      };
      return Object.values(attribution).some((value) => value) ? attribution : null;
    },
    async createUserCompany() {
      try {
        this.setLoader(true)
        const attribution = this.getAttribution();
        this.companyID = await this.createCompanyOnly({
          data: {
            ...this.company,
            expected_no_of_drivers: this.company.company_type === '1' ? 1 : this.company.expected_no_of_drivers,
            ...(attribution ? { attribution } : {})
          }, key: this.userKey
        })
        localStorage.setItem("token", this.userKey);
        localStorage.setItem("eula_accepted_at", this.eulaAccepted ? this.eulaAccepted : false)
        localStorage.setItem("userSelectedCompany", this.companyID)

        await this.setNotification({
          msg: this.$t('register.notifications.companyCreated'),
          type: "success",
          color: "green",
        });
        this.setLoader(false)
        try {
          const url = await this.getSubscriptionDetails();
          if (url) window.location.href = url
        }
        catch (e) {
          console.log(e)
        }
        // if (this.company.company_type === '2') this.step++
        // else this.$router.push("/all-companies");

      }
      catch (error) {
        this.setLoader(false)
        if (Array.isArray(error.error)) {
          this.setNotification({
            msg: error.error[0],
            type: "error",
            color: "red",
          });
        }
        else if (error.status || error.name)
          this.setNotification({
            msg: this.$t('register.notifications.companyNameExists'),
            type: "error",
            color: "red",
          });
      }
    },
    payloadToFormData(payload) {
      let formData = new FormData();
      for (let [key, value] of Object.entries(payload)) {
        if (key === "logo" && this.companyLogo) {
          formData.append(key, this.companyLogo, this.companyLogo.name);
        }
        else if (key !== "logo") {
          if (value !== null) {
            formData.append(key, value);
          }
        }

      }
      return formData;
    },
  },
  mounted() {
    this.user.email = (this.$route.query.email || '').replace(/\s+/g, '')
  }
};
</script>

<style>
@media (min-width: 1050px) and (max-width: 1700px) {
  .register-form .right-img {
    width: 100%;
  }

  /* .register-form .right-img img {
    height: 100%;
  } */
}

@media screen and (min-width: 1701px) {
  .auth-bg-img {
    height: 100vh;
  }
}

@media screen and (max-width: 1700px) {
  .auth-bg-img {
    height: auto;
  }
}

@media screen and (max-width: 1200px) {
  .auth-bg-img {
    height: auto;
  }
}

@media (max-width: 1210px) {
  .fix-width {
    width: auto !important;
  }

  /* .right-side img {
    height: 100%;
    object-fit: cover;
  } */
  .auth-bg-img {
    height: auto;
  }
}

@media (max-width: 991px) {
  .fix-width.register {
    width: 300px !important;
  }

  /* .right-img.right-side {
    height: 100%  !important;
  }
  .right-img.right-side img {
    height: 100%  !important;
  } */
}

@media (min-width: 768px) and (max-width: 1024px) {
  .auth-bg-img {
    height: calc(100vh - -60px);
  }
}

@media (max-width: 767px) {
  .auth-bg-img {
    display: none;
  }

  .left-side {
    display: block;
  }

  .fix-width.fix-width-login,
  .fix-width.register {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100% !important;
    padding-left: 15px;
    padding-right: 15px;
  }

  .register-steppers {
    height: 70vh;
    overflow-y: auto;
  }

  .copyright-text {
    position: fixed;
  }
}

@media (max-width: 575px) {
  .fix-width {
    width: auto !important;
  }
}

.password-2 .b-icon {
  top: 14px !important;
}

.otp-bubble {
  background-color: #F4F4F4;
  border-radius: 10px;
  padding: 12px 16px;
  color: black;
}</style>